export default __webpack_public_path__ + "static/media/product3.8a388350.jpg";